export const RESOURCE_TYPE_BOARDS_DIRECTORY = 'BOARDS_DIRECTORY';
